export const tableSize = {
  customer_id: 160,
  customer_name: 200,
  business_type: 140,
  caliber: 140,
  address: 500,
  office: 140,
  block_mid: 140,
  leak_hours: 170,
  leak_volume: 170,
  usage_volume: 170,
  leak_rate: 160,
  leak_type: 140,
  leak_severity: 140
}

export const ORG_COLOR_MAP = {
  국내: "#3b82f6",
  해외: "#f59e0b"
}

export const ORG_DATA = [
  {
    id: "seoul",
    name: { ko: "아리수 본부", en: "Seoul Arisu HQ", es: "Sede de Arisu de Seúl" },
    category: "국내",
    region: { ko: "서울특별시", en: "Seoul", es: "Seúl" },
    color: "#3b82f6",
    path: "org/seoul",
    logo: "/images/org-01-logo.png",
    logoHeight: 40
  },
  {
    id: "daegu",
    name: {
      ko: "대구광역시 상수도사업본부",
      en: "Daegu Waterworks HQ",
      es: "Sede de Obras Hidráulicas de Daegu"
    },
    category: "국내",
    region: { ko: "대구광역시", en: "Daegu", es: "Daegu" },
    color: "#3b82f6",
    path: "org/daegu",
    logo: "/images/org-02-logo.png",
    logoHeight: 40
  },
  {
    id: "jangheung",
    name: { ko: "장흥수도센터", en: "Jangheung Waterworks", es: "Centro de Agua de Jangheung" },
    category: "국내",
    region: {
      ko: "전라남도 장흥군",
      en: "Jangheung-gun, Jeollanam-do",
      es: "Jangheung-gun, Jeollanam-do"
    },
    color: "#3b82f6",
    path: "org/jangheung",
    logo: "/images/org-03-logo.png",
    logoHeight: 32
  },
  {
    id: "cubiq",
    name: { ko: "Cubiq Meters", en: "Cubiq Meters", es: "Cubiq Meters" },
    category: "국외",
    region: { ko: "말레이시아", en: "Malaysia", es: "Malasia" },
    color: "#f59e0b",
    path: "org/cubiq",
    logo: "/images/org-04-logo.png",
    logoHeight: 32
  }
]

export const ORG_CATEGORIES = ["국내", "국외"]

export const orgName = Object.fromEntries(ORG_DATA.map((org) => [org.id, org.name]))
